import React from 'react';
import { IslandButton, TrevorIcon } from '@trevor/ui-components';
import { SHOW_PIE_CHART_BUTTON } from '@/constants/test-ids';
import { NavigationButtonProps } from './types';

export const Pie: React.FC<NavigationButtonProps> = ({
  children,
  ...props
}) => (
  <IslandButton
    data-testid={SHOW_PIE_CHART_BUTTON}
    content={<TrevorIcon name="pie-chart" />}
    tooltipContent={
      props.$static ? 'Learn how to create a Pie chart' : 'Pie chart'
    }
    {...props}
  >
    {children}
  </IslandButton>
);
